export const UPDATE_SEARCH_CRITERIA = "updateSearchCriteria";

export const updateServiceWorksheetSearchCriteria = (
  dispatch,
  salesOrderNumber,
  templateId,
  userIds,
  date,
  status,
  offset,
  limit,
) => {
  dispatch({
    type: UPDATE_SEARCH_CRITERIA,
    salesOrderNumber,
    templateId,
    userIds,
    date,
    status,
    offset,
    limit,
  });
};
